/* global _ */

import api from './api';

const { noop } = _;

export default function( callback ) {
	callback = callback || noop;

	api( 'innoway/v2/about', {}, response => {
		callback( response.data || [] );
	} );
}
